import { TileButtonsContainer, TilePlayButton } from "@/components/ui-v2";

import type { GenerationTileAction } from "../GenerationTile/types";

interface AudioGenerationTileControlsProps {
  isPlaying: boolean;
  onAction: (event: React.MouseEvent, action: GenerationTileAction) => void;
}

export const AudioGenerationTileControls = (
  props: AudioGenerationTileControlsProps,
) => {
  const { isPlaying, onAction } = props;

  return (
    <TileButtonsContainer>
      <TilePlayButton isPlaying={isPlaying} onAction={onAction} />
    </TileButtonsContainer>
  );
};
